<template>
    <div class="space-y-6">
        <h2 class="text-heading-md">Card Checkbox Examples</h2>

        <div class="grid grid-cols-2 gap-8">
            <div>
                <h3 class="mb-3 text-content-lg font-semibold">Basic Card Checkboxes</h3>
                <small>(uses DsCardOptionList for spacing normalization and compact mode)</small>
                <DsCardOptionList>
                    <DsCardCheckbox
                        v-model="checkbox1"
                        label="Enable notifications"
                        name="notifications"
                        value="notifications"
                    >
                        <div>
                            <h4 class="text-content-lg font-semibold">Email Notifications</h4>
                            <p class="text-content-sm text-content-secondary">Receive important updates and alerts via email</p>
                        </div>
                    </DsCardCheckbox>

                    <DsCardCheckbox
                        v-model="checkbox2"
                        label="Enable analytics"
                        name="analytics"
                        value="analytics"
                    >
                        <div>
                            <h4 class="text-content-lg font-semibold">Usage Analytics</h4>
                            <p class="text-content-sm text-content-secondary">Help us improve by sharing anonymous usage data</p>
                        </div>
                    </DsCardCheckbox>

                    <DsCardCheckbox
                        v-model="checkbox3"
                        label="Marketing emails"
                        name="marketing"
                        value="marketing"
                    >
                        <div>
                            <h4 class="text-content-lg font-semibold">Marketing Updates</h4>
                            <p class="text-content-sm text-content-secondary">Receive news about new features and promotions</p>
                        </div>
                    </DsCardCheckbox>
                </DsCardOptionList>
                <div class="mt-3 text-content-sm text-content-secondary">Selected: {{ selectedCheckboxes }}</div>
            </div>

            <div>
                <h3 class="mb-3 text-content-lg font-semibold">Card Checkboxes with Right Position</h3>
                <DsCardOptionList>
                    <DsCardCheckbox
                        v-model="rightCheckbox1"
                        formControlPosition="right"
                        label="Premium features"
                        name="premium"
                        value="premium"
                    >
                        <div>
                            <h4 class="text-content-lg font-semibold">Premium Features</h4>
                            <p class="text-content-sm text-content-secondary">Access advanced tools and priority support</p>
                        </div>
                    </DsCardCheckbox>

                    <DsCardCheckbox
                        v-model="rightCheckbox2"
                        formControlPosition="right"
                        label="Beta access"
                        name="beta"
                        value="beta"
                    >
                        <div>
                            <h4 class="text-content-lg font-semibold">Beta Program</h4>
                            <p class="text-content-sm text-content-secondary">Try new features before they're released</p>
                        </div>
                    </DsCardCheckbox>
                </DsCardOptionList>
            </div>
        </div>

        <div class="grid grid-cols-2 gap-8">
            <div>
                <h3 class="mb-3 text-content-lg font-semibold">Card Checkbox with Error State</h3>
                <DsCardCheckbox
                    v-model="checkboxError"
                    :error="!checkboxError ? 'You must accept the terms to continue' : false"
                    label="Accept terms"
                    name="terms"
                    value="terms"
                >
                    <div>
                        <h4 class="text-content-lg font-semibold">Terms and Conditions</h4>
                        <p class="text-content-sm text-content-secondary">I agree to the terms of service and privacy policy</p>
                    </div>
                </DsCardCheckbox>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import DsCardOptionList from '@/components/design-system/form/input/DsCardOptionList.vue';
import DsCardCheckbox from '@ds/form/input/DsCardCheckbox.vue';
import { computed, ref } from 'vue';

// Checkbox states
const checkbox1 = ref(false);
const checkbox2 = ref(true);
const checkbox3 = ref(false);
const rightCheckbox1 = ref(false);
const rightCheckbox2 = ref(false);
const checkboxError = ref(false);

// Computed
const selectedCheckboxes = computed(() => {
    const selected = [];
    if (checkbox1.value) selected.push('notifications');
    if (checkbox2.value) selected.push('analytics');
    if (checkbox3.value) selected.push('marketing');
    return selected.length ? selected.join(', ') : 'none';
});
</script>
